import React from 'react';
import { CheckCircle2Icon, XCircleIcon, ArrowRightIcon } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    aspect: 'Tu hogar',
    sell: 'Debes mudarte inmediatamente',
    creditual: 'Sigues viviendo en tu casa',
    sellBad: true
  }, {
    aspect: 'Ingresos',
    sell: 'Un solo pago (que se gasta rápido)',
    creditual: 'Flujo mensual constante y ordenado',
    sellBad: false
  }, {
    aspect: 'Comisiones',
    sell: 'Pagas 2%–4% de corretaje',
    creditual: 'Sin comisión de corretaje',
    sellBad: true
  }, {
    aspect: 'Privacidad',
    sell: 'Visitas constantes de extraños',
    creditual: 'Proceso 100% privado',
    sellBad: true
  }, {
    aspect: 'Heredabilidad',
    sell: 'El activo ya no es tuyo',
    creditual: 'Los pagos restantes son heredables',
    sellBad: true
  }];
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="comparacion" className="py-12 md:py-24 bg-white relative overflow-hidden" data-id="element-982">
      <div className="container mx-auto max-w-5xl px-4" data-id="element-983">
        <div className="text-center mb-8 md:mb-12" data-id="element-984">
          <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4 text-[#0A1628]" data-id="element-985">
            La diferencia frente a una venta tradicional
          </h2>
          <p className="text-sm md:text-lg text-[#6B7280] max-w-2xl mx-auto" data-id="element-986">
            Evitas el estrés de mostrar tu casa, negociar precios y pagar
            comisiones.
          </p>
        </div>

        {/* Desktop table */}
        <div className="hidden md:block" data-id="element-987">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden" data-id="element-988">
            {/* Header */}
            <div className="grid grid-cols-3 bg-[#F8FAFC]" data-id="element-989">
              <div className="p-6 border-r border-gray-200" data-id="element-990">
                <p className="text-sm font-medium text-[#6B7280]" data-id="element-991">Aspecto</p>
              </div>
              <div className="p-6 border-r border-gray-200 bg-red-50" data-id="element-992">
                <p className="text-lg font-bold text-red-700" data-id="element-993">
                  Venta tradicional
                </p>
              </div>
              <div className="p-6 bg-[#2B5FD9]/5" data-id="element-994">
                <p className="text-lg font-bold text-[#2B5FD9]" data-id="element-995">
                  Modelo Creditual
                </p>
              </div>
            </div>

            {/* Rows */}
            {comparisons.map((row, index) => <div key={index} className={`grid grid-cols-3 ${index !== comparisons.length - 1 ? 'border-b border-gray-200' : ''}`} data-id="element-996">
                <div className="p-6 border-r border-gray-200" data-id="element-997">
                  <p className="font-semibold text-[#0A1628]" data-id="element-998">{row.aspect}</p>
                </div>
                <div className="p-6 border-r border-gray-200 flex items-start gap-3" data-id="element-999">
                  {row.sellBad ? <XCircleIcon className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-1000" /> : <div className="h-5 w-5 flex-shrink-0" data-id="element-1001" />}
                  <p className={`text-sm ${row.sellBad ? 'text-red-700' : 'text-[#6B7280]'}`} data-id="element-1002">
                    {row.sell}
                  </p>
                </div>
                <div className="p-6 flex items-start gap-3 bg-[#2B5FD9]/5" data-id="element-1003">
                  <CheckCircle2Icon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-1004" />
                  <p className="text-sm text-[#0A1628] font-medium" data-id="element-1005">
                    {row.creditual}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden space-y-4" data-id="element-1006">
          {comparisons.map((row, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1007">
              <div className="bg-[#F8FAFC] px-4 py-3 border-b border-gray-200" data-id="element-1008">
                <p className="font-semibold text-[#0A1628]" data-id="element-1009">{row.aspect}</p>
              </div>
              <div className="grid grid-cols-2" data-id="element-1010">
                <div className="p-4 border-r border-gray-200 bg-red-50/50" data-id="element-1011">
                  <p className="text-xs font-semibold text-red-700 mb-2" data-id="element-1012">
                    Vender
                  </p>
                  <div className="flex items-start gap-2" data-id="element-1013">
                    {row.sellBad && <XCircleIcon className="h-4 w-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-1014" />}
                    <p className="text-xs text-red-700" data-id="element-1015">{row.sell}</p>
                  </div>
                </div>
                <div className="p-4 bg-[#2B5FD9]/5" data-id="element-1016">
                  <p className="text-xs font-semibold text-[#2B5FD9] mb-2" data-id="element-1017">
                    Creditual
                  </p>
                  <div className="flex items-start gap-2" data-id="element-1018">
                    <CheckCircle2Icon className="h-4 w-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-1019" />
                    <p className="text-xs text-[#0A1628]" data-id="element-1020">{row.creditual}</p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA */}
        <div className="text-center mt-10" data-id="element-1021">
          <button onClick={() => scrollToSection('simulador')} className="inline-flex items-center gap-2 px-6 py-3 bg-[#2B5FD9] text-white font-semibold rounded-xl hover:bg-[#1E4BB8] transition-colors" data-id="element-1022">
            <span data-id="element-1023">Ver si califico</span>
            <ArrowRightIcon className="h-4 w-4" data-id="element-1024" />
          </button>
        </div>
      </div>
    </section>;
}